import { defineMessages } from 'react-intl';

const messages = defineMessages({
  visitFeedback: {
    id: 'repvisits.staff.ratings.visitFeedback',
    defaultMessage: 'Visit Feedback',
  },
  turnedOff: {
    id: 'repvisits.staff.ratings.turnedOff',
    defaultMessage: 'Visit Feedback is <strong>turned off</strong>. High schools won\'t receive feedback requests',
  },
  turnedOn: {
    id: 'repvisits.staff.ratings.turnedOn',
    defaultMessage: 'Visit Feedback is <strong>turned on</strong>. High schools will receive feedback requests',
  },
  turnOff: {
    id: 'repvisits.staff.ratings.turnOff',
    defaultMessage: 'Turn Off?',
  },
  turnOn: {
    id: 'repvisits.staff.ratings.turnOn',
    defaultMessage: 'Turn On?',
  },
  successTurnedOnMessage: {
    id: 'repvisits.staff.ratings.successTurnedOnMessage',
    defaultMessage: 'Visit Feedback is turned ON',
  },
  successTurnedOffMessage: {
    id: 'repvisits.staff.ratings.successTurnedOffMessage',
    defaultMessage: 'Visit Feedback is turned OFF',
  },
  failureTurnedOnOffMessage: {
    id: 'repvisits.staff.ratings.failureTurnedOnOffMessage',
    defaultMessage: 'Something unexpected happened. Please try your request again.',
  },
  toggleModalHeader: {
    id: 'repvisits.staff.ratings.toggleModalHeader',
    defaultMessage: 'Collecting Visit Feedback',
  },
  toggleModalMessage: {
    id: 'repvisits.staff.ratings.toggleModalMessage',
    defaultMessage: 'Would you like high schools to send you Visit Feedback?',
  },
  yesToVisitFeedback: {
    id: 'repvisits.staff.ratings.yesToVisitFeedback',
    defaultMessage: 'Yes',
  },
  noToVisitFeedback: {
    id: 'repvisits.staff.ratings.noToVisitFeedback',
    defaultMessage: 'No',
  },
});

export default messages;
